import { transformDuplicateTemplateToCreatorState } from "./templateDataTransformers";
import { hasTemplateVariableValue } from "./campaignTemplateUtils";

/**
 * Build TemplatePreview state from an API template + variable form values.
 */
export function buildTemplatePreviewState(template, variableValues = {}) {
  if (!template) return null;
  let state = transformDuplicateTemplateToCreatorState(template);

  if (!state.headerFilePreview) {
    let templateJson = template.template_json || {};
    if (typeof templateJson === "string") {
      try {
        templateJson = JSON.parse(templateJson);
      } catch {
        templateJson = {};
      }
    }
    const headerComp = (templateJson.components || []).find(
      (c) => c.type === "HEADER"
    );
    const handle = headerComp?.example?.header_handle?.[0];
    if (handle && String(handle).includes("http")) {
      state = { ...state, headerFilePreview: handle };
    }
  }

  return applyCampaignVarsToPreviewState(state, variableValues);
}

/**
 * Apply campaign-level default variables to TemplatePreview state samples.
 */
export function applyCampaignVarsToPreviewState(state, campaignVars = {}) {
  if (!state || !campaignVars || typeof campaignVars !== "object") {
    return state;
  }

  const pickValue = (names) => {
    for (const key of names) {
      const val = campaignVars[key];
      if (hasTemplateVariableValue(val)) {
        return String(val);
      }
    }
    return null;
  };

  const headerVariables = (state.headerVariables || []).map((v) => {
    const sample =
      pickValue([`header_${v.name}`, v.name]) || v.sample;
    return { ...v, sample };
  });

  let bodyVariables = (state.bodyVariables || []).map((v) => {
    const sample =
      pickValue([`body_${v.name}`, v.name]) || v.sample;
    return { ...v, sample };
  });

  if (
    String(state.category || "").toUpperCase() === "AUTHENTICATION" &&
    bodyVariables.length === 0
  ) {
    const otp = pickValue(["body_1", "otp", "code"]);
    if (otp) {
      bodyVariables = [{ name: "1", sample: otp }];
    }
  }

  const ctaButtons = (state.ctaButtons || []).map((btn, index) => {
    const urlVar = pickValue([`button_text_${index}`]);
    if (urlVar && btn.url_type === "dynamic") {
      return { ...btn, urlVariableSample: urlVar };
    }
    return btn;
  });

  const mediaUrl = pickValue([
    "header_image_link",
    "header_image_url",
    "header_video_link",
    "header_video_url",
    "header_document_link",
    "header_document_url",
  ]);

  return {
    ...state,
    headerVariables,
    bodyVariables,
    ctaButtons,
    headerFilePreview: mediaUrl || state.headerFilePreview,
  };
}
